/**
 * Legacy strings for الحوادث السيبرانية and التحقق من صحة الشهادة —
 * Admin/SecurityReportsManagement.ar.resx and Admin/CertificateSettings.ar.resx.
 */
export const incidentsStrings = {
  sections: { reports: 'البلاغات', settings: 'الإعدادات' },
  categoryForm: 'إضافة تصنيف',
  categoryEdit: 'تعديل التصنيف',
  title: 'إدارة الحوادث السيبرانية', // SecurityReportsManagement.PanelHeading
  subtitle: 'مراجعة التقارير الأمنية في النظام', // PanelSubHeading
  manageCategories: 'إعدادات الحوادث السيبرانية', // btnManageCategories
  featureSwitch: 'تفعيل خاصية الحوادث السيبرانية',
  displayOptions: 'خيارات عرض البلاغات',

  columns: {
    index: 'م', // TableHead_1
    id: 'رقم البلاغ', // TableHead_2
    title: 'عنوان البلاغ', // TableHead_3
    category: 'الفئة', // TableHead_4
    createdOn: 'تاريخ الإنشاء', // TableHead_5
    lastUpdate: 'آخر تحديث', // TableHead_6
    reporter: 'مقدم البلاغ', // TableHead_7
    state: 'حالة البلاغ', // TableHead_8
  },

  row: {
    view: 'مشاهدة التفاصيل', // btnView
  },

  /* ---- the report drawer: none of this screen existed before the API was wired ---- */
  changeState: 'حالة البلاغ',
  subCategory: 'التصنيف الفرعي',
  noSubCategory: 'دون تصنيف فرعي',
  changeStateHint: 'يرسل إشعار إلى مقدم البلاغ عند تغيير الحالة',
  stateSaved: 'تم تحديث الحالة',
  details: 'بيانات البلاغ',
  reportContent: 'محتوى البلاغ',
  messagePreview: 'معاينة الرسالة',
  previewSafety: 'معاينة آمنة. الصور والروابط والمحتوى التفاعلي معطلة لحمايتك.',
  technicalDetails: 'التفاصيل التقنية للبلاغ',
  download: 'تنزيل',
  attachments: 'المرفقات',
  comments: 'التعليقات',
  noComments: 'لا توجد تعليقات على هذا البلاغ',
  addComment: 'إضافة تعليق',
  commentAdded: 'تمت إضافة التعليق',
  commentPlaceholder: 'اكتب تعليقا يظهر لمقدم البلاغ',
  notFound: 'البلاغ غير موجود',
  notFoundHint: 'قد يكون البلاغ قد حذف، أو أن الرقم غير صحيح',

  /* ---- the categories drawer ---- */
  categoriesHint: 'الفئات التي يختار منها المستخدم عند رفع بلاغ',
  category: {
    nameAr: 'الاسم بالعربية',
    nameEn: 'الاسم بالإنجليزية',
    parent: 'الفئة الرئيسية',
    parentHint: 'اتركها فارغة لتكون فئة رئيسية',
    noParent: 'بدون فئة رئيسية',
    existing: 'الفئات الحالية',
    empty: 'لا توجد فئات بعد — لا يمكن تفعيل الخاصية قبل إضافة فئة واحدة على الأقل',
    deleteConfirm: 'سيحذف هذا التصنيف وكل تصنيفاته الفرعية نهائيا. لا يمكن الحذف إذا كان أي منها مستخدما في بلاغ.',
  },

  addNew: 'إضافة',
  edit: 'تعديل',
  delete: 'حذف',
  saved: 'تم الحفظ بنجاح',
  deleted: 'تم الحذف بنجاح',
  namesRequired: 'الاسم بالعربية والإنجليزية مطلوبان',
  empty: 'لا توجد بلاغات',
  actionFailed: 'تعذر إتمام العملية',
  fail: {
    list: 'تعذر تحميل البلاغات',
    settings: 'تعذر تحميل إعدادات البلاغات',
    saveCategory: 'تعذر حفظ تصنيف البلاغات',
    deleteCategory: 'تعذر حذف تصنيف البلاغات',
    state: 'تعذر تغيير حالة البلاغ',
    comment: 'تعذر إضافة التعليق',
  },

  /** SecurityReportState — LanguageConstants.cs:59-69, stored as the enum name. */
  states: {
    New: 'جديد',
    InProgress: 'قيد العمل',
    Completed: 'منتهي (بلاغ صحيح)',
    Closed: 'ملغي (بلاغ خاطئ)',
  },

  /** The legacy pre-checks the first two states on load. */
  /* EMPTY, which the page reads as `no state filter` — every report, whatever
     its state. It opened on New + InProgress, so two of the four cards were
     already narrowing the list before anyone chose anything, and the totals
     above disagreed with the rows below. */
  defaultStates: [],

  /** The summary strip. Every figure comes from rows the page already holds. */
  stats: {
    caption: 'ملخص البلاغات',
    total: 'إجمالي البلاغات',
  },

  apply: 'تحديث',
  cancel: 'إلغاء',
  close: 'إغلاق',
}

export const validationStrings = {
  title: 'التحقق من الشهادات', // the menu entry's own name — the page said 'إدارة الشهادات' (Taiga #1544)
  panelTitle: 'التحقق من صحة الشهادة', // PanelTitleCertificateValidation
  heading:
    'أدخل رمز التحقق المطبوع على الشهادة (6 أو 12 خانة) بدون البادئة إن وجدت، للتحقق من صحتها.', // PanelCertificateValidationHeading
  placeholder: 'رمز التحقق', // InTxtValidationCodePlaceHolder
  validate: 'التحقق', // BtnValidate
  invalidCode: 'فضلا قم بإدخال رمز تحقق صالح', // MessageInvalidCode
  checkFailed: 'تعذر التحقق من الرمز الآن، حاول مرة أخرى',

  validHead: 'شهادة مصدقة', // MessageValidCertificateHead
  validSubHead: 'رمز الشهادة صالح، وقد تم إصدار الشهادة من النظام.', // MessageValidCertificateSubHead
  invalidHead: 'شهادة غير مصدقة', // MessageInvalidCertificateHead
  invalidSubHead: 'لم يتم العثور على الرمز المطلوب', // MessageInvalidCertificateSubHead

  fields: {
    identifier: 'رمز التحقق', // TableHeadCertificateIdentifier
    printedBy: 'طباعة بواسطة', // TableHeadPrintedByUsername
    printedFor: 'طباعة لمستخدم', // TableHeadPrintedForUsername
    issueDate: 'تاريخ الطباعة', // TableHeadIssueDate
    printedName: 'الاسم المطبوع', // TableHeadPrintedName
    printedProgram: 'اسم البرنامج المطبوع', // TableHeadPrintedProgramName
    printedCertDate: 'التاريخ المطبوع', // TableHeadPrintedCertificateDate
    language: 'لغة الطباعة', // TableHeadPrintLanguage
  },
}
